import React, {Component} from 'react'
import {Input, InputGroup, InputGroupAddon, Button} from 'reactstrap'
import {AvForm} from 'availity-reactstrap-validation'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import addProjectBudgetsMutation from '../../queries/server/mutations/add_project_budgets'
import editProjectLocalMutation from '../../queries/client_side/mutations/edit_project'
import AUSelectGenerator from '../components/auto_updaters/ValidSelectInput'

const AUSelectProjectActivities = AUSelectGenerator('project_activity_types', 'project_activity_type_id description', 'project_activity_type_id', ['description'])

class ProjectBudgetInput extends Component {

    state = {
        project_activity_type_id: '',
        description: '',
        address_id: '',
        stage: ''
    }

    constructor(props) {
        super(props)

        this.form = null

        this.state = {
            project_activity_type_id: props.project_activity_type_id || '',
            description: props.description || '',
            address_id: props.address_id || '',
            stage: props.stage || '',
        }
    }

    setValue = (key, value) => {
        const newState = {...this.state}
        newState[key] = value
        this.setState(newState)
    }

    reset = () => {
        if(this.props.resetForm){
            this.form.reset()
            this.setState({
                project_activity_type_id: '',
                description: '',
                address_id: '',
                stage: ''
            })
        }

    }

    render() {

        const {
            project_activity_type_id,
            description,
            address_id,
            stage,
        } = this.state

        const {
            project_id,
            addresses,
            id,
            onSaved,
            onCancel,
            resetForm,
            successMessage
        } = this.props

        return (
            <Mutation mutation={addProjectBudgetsMutation}>
                {(addProjectBudgetsMutationFunc, {loading}) => (
                    <Mutation mutation={editProjectLocalMutation}>
                        {(editProjectLocalMutationFunc) => (
                            <AvForm
                                className="d-flex flex-row mb-0 pb-0" style={{flex: '1'}}
                                ref={ref => this.form = ref}
                                onValidSubmit={() => {
                                    addProjectBudgetsMutationFunc({
                                        variables:
                                            {
                                                project_id,
                                                data: [{
                                                    id: id || null,
                                                    project_activity_type_id,
                                                    description: description || null,
                                                    address_id: address_id || null,
                                                    stage: stage || null
                                                }]
                                            }
                                    })
                                        .then(({data}) => {
                                            if (onSaved) onSaved()
                                            editProjectLocalMutationFunc({variables: {data: data.upsertProjectBudgets}})
                                            this.reset()
                                            toast.success(successMessage, {autoClose: 2000})
                                        })
                                        .catch(e => toast.error(e.message, {autoClose: false}))
                                }}
                            >
                                <div className="d-flex mr-2 mb-0 pb-0" style={{flex: '1'}}>
                                    <AUSelectProjectActivities
                                        required
                                        name="project_activity_type_id"
                                        bsSize="sm"
                                        value={project_activity_type_id}
                                        onChange={(value) => this.setValue('project_activity_type_id', value)}
                                    />
                                </div>

                                <div className="d-flex mr-2" style={{flex: '1'}}>
                                    <Input
                                        className="form-control-sm"
                                        placeholder="Description"
                                        value={description}
                                        onChange={(evt) => this.setValue('description', evt.target.value)}
                                    />
                                </div>
                                <div className="d-flex mr-2" style={{flex: '1'}}>
                                    <Input
                                        type="select"
                                        name="site"
                                        id="site"
                                        className="form-control-sm"
                                        value={address_id}
                                        onChange={(evt) => this.setValue('address_id', evt.target.value)}
                                    >
                                        <option value={''}>Select Site</option>
                                        {addresses && addresses.map(({address_id, full_address}) => (
                                            <option value={address_id}>{full_address}</option>
                                        ))}
                                    </Input>
                                </div>
                                <div className="d-flex mr-2" style={{flex: '1'}}>
                                    <Input
                                        placeholder="Stage"
                                        className="form-control-sm"
                                        value={stage}
                                        onChange={(evt) => this.setValue('stage', evt.target.value)}
                                    />
                                </div>


                                <Button
                                    size="sm"
                                    color="secondary"
                                    onClick={() => {
                                        if (onCancel) onCancel()
                                    }}
                                    className="mr-1 square-btn"
                                >
                                    <FontAwesomeIcon color="#fff" icon="times"/>
                                </Button>

                                <Button
                                    size="sm"
                                    color="success"
                                    disabled={loading}
                                    className="square-btn"
                                >
                                    <FontAwesomeIcon color="#fff" icon="save"/>
                                    {loading && 'Saving...'}
                                </Button>


                            </AvForm>
                        )}
                    </Mutation>
                )}

            </Mutation>
        )
    }


}

ProjectBudgetInput.propTypes = {
    project_id: PropTypes.string.isRequired,
    addresses: PropTypes.array,
    id: PropTypes.number,
    project_activity_type_id: PropTypes.number,
    description: PropTypes.string,
    address_id: PropTypes.number,
    stage: PropTypes.string,
    onSaved: PropTypes.func,
    onCancel: PropTypes.func,
    resetForm: PropTypes.bool,
    successMessage: PropTypes.string
}

export default ProjectBudgetInput